export enum CalendarSlotState {
  Empty = 0,
  Generated = 1,
  Booked = 2,
  Reserved = 3
}
